var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBox16W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 2H12.6667C13.4067 2 14 2.6 14 3.33333V12.6667C14 13.4 13.4067 14 12.6667 14H3.33333C2.59333 14 2 13.4 2 12.6667V3.33333C2 2.6 2.59333 2 3.33333 2ZM3.33333 8L6.66667 11.3333L12.6667 5.33333L11.7267 4.38667L6.66667 9.44667L4.27333 7.06L3.33333 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox16W);
export default __webpack_public_path__ + "static/media/check_box_16w.6eaee573a67e03394cfba944ae7b0147.svg";
export { ForwardRef as ReactComponent };